import React from "react";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, A11y } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';
import "swiper/swiper-bundle.css";
import "swiper/css/effect-fade";
import { useNavigate } from 'react-router-dom';


const Hero = (props) => {

    const navigation = useNavigate();

    return (

        <>
            {props.banner &&

                <>
                    <Swiper slidesPerView={1}
                        loop={true}
                        modules={[Autoplay, Scrollbar, Pagination]}
                        //autoplay={false}
                        autoplay={{
                            delay: 8000,
                            disableOnInteraction: false,
                        }}
                        speed={1500}
                        pagination={{ clickable: true }}
                    >

                        <SwiperSlide>
                            <div className="hero">
                                <div className=" bg-dark text-white border-0">
                                    <img src={`${process.env.REACT_APP_BACKEND}assets/schools/banner/${props.banner}`} className="card-img" alt="pews Banner" />
                                </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>
                </>
            }

            {!props.banner &&
                <>
                    <Swiper slidesPerView={1}
                        loop={true}
                        modules={[Autoplay, Scrollbar, Pagination, Navigation, A11y, EffectFade]}
                        effect={"fade"}
                        // autoplay={false}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        // grabCursor="true"
                        speed={1500}
                        pagination={{ clickable: true }}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}

                    >

                        <SwiperSlide>

                            <div className="hero">
                                <div className="absolute" onClick={() => navigation('/register')}>
                                    <div className="glow">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        Admission Open, Apply Now
                                    </div>
                                </div>
                                <div className=" bg-dark text-white border-0">
                                    <img src="/assets/banner/Home-1.webp" className="card-img" alt="pews Banner admission" />
                                </div>
                            </div>


                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="hero">
                                <div className=" bg-dark text-white border-0">
                                    <img src="/assets/banner/Home-2.jpg" className="card-img" alt="Banner" />
                                </div>
                            </div> */}

                            <div className="hero">
                                <div className="absolute" onClick={() => navigation('/register')}>
                                    <div className="  glow">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        Admission Open, Apply Now
                                    </div>
                                </div>
                                <div className=" bg-dark text-white border-0">
                                    <img src="/assets/banner/Home-2.webp" className="card-img" alt="pews Banner admission open" />
                                </div>
                            </div>


                        </SwiperSlide>

                        <SwiperSlide>
                            {/* <div className="hero">
                                <div className=" bg-dark text-white border-0">
                                    <img src="/assets/banner/Home-3.jpg" className="card-img" alt="Banner" />
                                </div>
                            </div> */}

                            <div className="hero">
                                <div className="absolute" onClick={() => navigation('/register')}>
                                    <div className="  glow">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        Admission Open, Apply Now
                                    </div>
                                </div>
                                <div className=" bg-dark text-white border-0">
                                    <img src="/assets/banner/Home-3.webp" className="card-img" alt="pews Banner open" />
                                </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>
                </>

            }

        </>
    );
}

export default Hero;